import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {withConfig, withI18n} from 'spa/Components/Context';
import TrustPilotReview from 'spa/Components/TrustPilotReview';
import PressFeatured from './PressFeatured';

import LazyLoad from 'react-lazyload';

import 'spa/styles/home.less';
import './HomeNumberOneSection.less';

@observer
@withConfig
@withI18n
class HomeNumberOneSection extends React.Component {
  static propTypes = {
    isLandingPage: PropTypes.bool,
  }

  static defaultProps = {
    isLandingPage: false,
  }

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;

    this.showFeaturedPress = config.getValue('b2c.show-featured-press', i18n.umRegion);
    this.showTrustPilotReviews = config.getValue('b2c.show-trustpilot-reviews', i18n.umRegion);
  }

  render() {
    const {showFeaturedPress, showTrustPilotReviews} = this;
    const {i18n} = this.context;
    const {isLandingPage} = this.props;

    return (
      <div className="home-content-section home-number-one-section home-content-section--no-padding-bottom row">
        {(showTrustPilotReviews && !isLandingPage) ? ([
          <div
            key="home-number-one-section-photo-wrapper"
            className="home-number-one-section__photos-wrapper">
            <h2
              className="typography--section-heading typography--guttered-wide-heading typography--centered"
            >
              {i18n._x('What others are saying:', 'Homepage section title')}
            </h2>
          </div>,
          <div
            key="home-number-one-section-trustpilot"
            className="home-number-one-section__trustpilot row">
            <div className="home-number-one-section__trustpilot-container container">
              <LazyLoad
                offset={100}
                placeholder={
                  <div />
                }>
                <TrustPilotReview
                  linkText={i18n._x(
                    'Urban Massage on Trustpilot',
                    'Trustpilot default link text',
                  )}
                  locale={i18n.locale}
                  type="review"
                />
              </LazyLoad>
            </div>
          </div>,
        ]) : null}
        {showFeaturedPress ? (
          <div className="home-number-one-section__press row">
            <h3
              className="home-content-section__title home-content-section__title home-content-section__title--centered home-content-section__title--black home-number-one-section__press-title"
            >
              {i18n._x('As featured in', 'Homepage section title')}
            </h3>
            <PressFeatured />
          </div>
        ) : null}
      </div>
    );
  }
}

export default HomeNumberOneSection;



// WEBPACK FOOTER //
// ./spa/Pages/Home/HomeNumberOneSection.jsx